module.exports = __webpack_public_path__ + "img/News.b704c711.png";